module.exports = __webpack_public_path__ + "static/media/home-bg-6.6253c7b4.jpg";